import { Navigation } from 'components'
import Text from 'components/priority/Text/Text'

export const StatusMessage = () => {
  return (
    <>
      <Navigation type="admin" />
      <Text margin="32px 0 0 0">Status Message</Text>
    </>
  )
}

export default StatusMessage
